export enum ManualPdfType {
    Undefined = "Undefined",
    Manual = "Manual",
    Navigation = "Navigation",
    Radio = "Radio",
    Documentation = "Documentation",
    TechnicalChange = "TechnicalChange",
    BriefInstructions = "BriefInstructions",
    LPG_Supplement = "LPG_Supplement",
    Connect = "Connect"
}